"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const app_1 = require("app");
const react_transition_group_1 = require("react-transition-group");
const webexUI_1 = require("webexUI");
const animationClassNames = {
    enter: 'translate-x-full',
    enterActive: 'translate-x-0 transition-transform duration-300 ease-in-out',
    exit: 'translate-x-0',
    exitActive: 'translate-x-full transition-transform duration-300 ease-in-out',
};
const Sidebar = ({ className, close, closeBreakpoint, opened, children, isAnimated = true, }) => {
    const sidebarRef = React.useRef(null);
    const listenerFn = React.useCallback(() => { }, []);
    const onWindowResize = React.useCallback(() => {
        if (close &&
            closeBreakpoint !== undefined &&
            (0, webexUI_1.detectBreakpoint)(closeBreakpoint) &&
            opened === true) {
            close();
        }
    }, [close, closeBreakpoint, opened]);
    const throttledResizeHandler = React.useMemo(() => (0, webexUI_1.throttle)(onWindowResize, 200), [onWindowResize]);
    React.useEffect(() => {
        window.addEventListener('resize', throttledResizeHandler);
        const sidebarNode = sidebarRef.current;
        sidebarNode === null || sidebarNode === void 0 ? void 0 : sidebarNode.addEventListener('touchstart', listenerFn, true);
        return () => {
            window.removeEventListener('resize', throttledResizeHandler);
            sidebarNode === null || sidebarNode === void 0 ? void 0 : sidebarNode.removeEventListener('touchstart', listenerFn);
        };
    }, [listenerFn, throttledResizeHandler]);
    const classes = React.useMemo(() => (0, app_1.cn)('fixed inset-y-0 right-0 w-full min-w-[320px] bg-white z-[50]', className), [className]);
    return ((0, jsx_runtime_1.jsx)("div", { ref: sidebarRef, "data-testid": `sidebar-${opened ? 'opened' : 'closed'}`, children: (0, jsx_runtime_1.jsx)(react_transition_group_1.TransitionGroup, { children: opened ? ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { classNames: isAnimated ? animationClassNames : '', timeout: 300, children: (0, jsx_runtime_1.jsx)("div", { className: classes, children: children }) }, "sidebar")) : null }) }));
};
exports.Sidebar = Sidebar;
